export default __webpack_public_path__ + "static/freight-big-pro-black-3a9ba12f94df9bd80c9431f55c972d6c.woff";